import EnumField from '@components/common/form/formik/input/EnumField';
import LabeledField from '@components/common/form/formik/input/LabeledField';
import React from 'react';
import { CourseLevel, Field as FieldEnum } from '@data/course/courseData';

const GenericInfo: React.FC = () => {
  return (
    <>
      <LabeledField label='Course Name' name='name' className='px-2 py-1' />
      <EnumField label='Field' name='field' enumToUse={FieldEnum} />
      <EnumField label='Course Level' name='courseLevel' enumToUse={CourseLevel}></EnumField>
      <LabeledField
        label='Description'
        name='description'
        className='align-middle'
        as='textarea'
        rows={3}
        cols={40}
      />
      <LabeledField
        label='Prerequisite Notes'
        name='prereqNotes'
        className='align-middle'
        as='textarea'
        rows={3}
        cols={40}
      />
      <LabeledField label='Zoom Link' name='zoomLink'></LabeledField>
    </>
  );
};

export default GenericInfo;
